import type { AccountResource } from "@follosoft/react-components";

/**
 * Resolves the logo to display for an account, preferring the logo of the
 * company linked to the current subdomain (`company_logo`) when present and
 * falling back to the account logo otherwise.
 *
 * `company_logo` is not yet part of the published `AccountResource` type, so
 * it is read through a narrow cast until the shared package exposes it.
 */
export const getAccountLogo = (
  account?: AccountResource | null,
): string | undefined => {
  const attributes = account?.attributes as
    | { company_logo?: string | null; logo?: string }
    | undefined;

  return attributes?.company_logo ?? attributes?.logo;
};
